/**
 * Authenticating requests to backend.
 * Permissions are set for 'amplify-nhlhub-prod-133423-authRole'
 * via the 'amplify-backend-policy'.
 */

import { fetchAuthSession } from 'aws-amplify/auth';

import {
  AWS_REGIONS,
  LONG_LAMBDA_TIMEOUT_MS,
} from '../utilities/lambdaConfig';

const AWS = require('aws-sdk');

export default class AwsClienService {
  async getCredentials() {
    const { credentials } = await fetchAuthSession();

    if (!credentials) {
      throw new Error(
        'AWS credentials are unavailable. The user may need to sign in again.'
      );
    }

    return credentials;
  }

  async getS3() {
    const credentials = await this.getCredentials();

    return new AWS.S3({
      credentials,
      region: AWS_REGIONS.EU_CENTRAL_1,
      signatureVersion: 'v4',
      useAccelerateEndpoint: true,
    });
  }

  async getLambda(region, options = {}) {
    const credentials = await this.getCredentials();

    return new AWS.Lambda({
      ...options,
      credentials,
      region,
    });
  }

  getLambdaEU() {
    return this.getLambda(AWS_REGIONS.EU_CENTRAL_1);
  }

  getLambdaUS() {
    return this.getLambda(AWS_REGIONS.US_EAST_1, {
      httpOptions: {
        timeout: LONG_LAMBDA_TIMEOUT_MS,
      },
    });
  }

  async getCognito() {
    const credentials = await this.getCredentials();

    return new AWS.CognitoIdentityServiceProvider({
      credentials,
      region: AWS_REGIONS.EU_CENTRAL_1,
    });
  }
}